import { Navigate, createFileRoute } from '@tanstack/react-router'
import { useAuthStore } from '@unsw/store'

export const Route = createFileRoute('/')({
  component: IndexPage,
})

function IndexPage() {
  const user = useAuthStore((state) => state.user)

  // Redirect to dashboard if authenticated, otherwise to login
  if (user) {
    return <Navigate to="/dashboard" />
  }

  return <Navigate to="/login" />
}
